var generateReportsAjax = (function () {
    function generateReport(reportType, reportData, callback) {
        data = {
          token: $.session.Token,
          reportType, 
          reportData
        };
        $.ajax({
          type: 'POST',
          url:
            $.webServer.protocol +
            '://' +
            $.webServer.address +
            ':' +
            $.webServer.port +
            '/' +
            $.webServer.serviceName +
            '/generateReport/',
          data: JSON.stringify(data),
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
          success: function (response, status, xhr) {
            var res = response.generateReportResult;
            callback(res);
          },
          error: function (xhr, status, error) {
            //alert("Error\n-----\n" + xhr.status + '\n' + xhr.responseText);
          },
        });
      }

    function checkIfReportExists(res, callback) {
        data = {
          token: $.session.Token,
          reportScheduleId: res[0].reportScheduleId,
        };
        $.ajax({
          type: 'POST',
          url:
            $.webServer.protocol +
            '://' +
            $.webServer.address +
            ':' +
            $.webServer.port +
            '/' +
            $.webServer.serviceName +
            '/checkIfReportExists/',
          data: JSON.stringify(data),
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
          success: function (response, status, xhr) {
            var res = response.checkIfReportExistsResult;
            callback(res, data.reportScheduleId);
          },
          error: function (xhr, status, error) {
            //alert("Error\n-----\n" + xhr.status + '\n' + xhr.responseText);
          },
        });
      }

    function viewReport(reportScheduleId) {
        $.ajax({
            type: 'POST',
            url: $.webServer.protocol + '://' + $.webServer.address + ':' + $.webServer.port + '/' + $.webServer.serviceName + '/viewReport/',
            data: '{"token":"' + $.session.Token + '", "reportScheduleId":"' + reportScheduleId + '"}',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response, status, xhr) {  
                var arr = response.viewReportResult._buffer;
                var byteArray = new Uint8Array(arr);
                var blob = new Blob([byteArray], { type: 'application/pdf' });
                if ($.session.browser == 'Explorer' || $.session.browser == 'Mozilla') {
                    window.navigator.msSaveOrOpenBlob(blob, 'report.pdf');
                } else {
                    var fileURL = URL.createObjectURL(blob);
                    window.open(fileURL);
                }
                reports.handledProcessedReport();
            }
        });
    }

    return {
        generateReport,
        checkIfReportExists,
        viewReport
    };
  })();
  